const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/

export const isValidUrl = (url) => urlRegex.test(url);

